module.exports = __webpack_public_path__ + "img/2_85.3319d47c.png";